import request from 'config/axios'
import INVOICE_TYPE from 'utils/invoiceType'

const configs = {
  responseType: 'arraybuffer'
}

const getInvoicesList = ({ accountType, type, startDate, endDate }) =>
  `gringott/invoices/${accountType}/${type}?startDate=${startDate}&endDate=${endDate}`

const getTypes = 'gringott/invoices/'

const getInvoice = ({ invoiceNumber, date, invoiceType, accountType, custodyId }) => {
  const prefix = `/gringott/invoices/report/${accountType}/${invoiceType}`
  switch (invoiceType) {
    case INVOICE_TYPE.RV:
      return `${prefix}?date=${date}&invoiceNumber=${invoiceNumber}`
    case INVOICE_TYPE.TD:
      return `${prefix}?invoiceNumber=${invoiceNumber}&custodyId=${custodyId}`
    default:
      return `${prefix}?invoiceNumber=${invoiceNumber}`
  }
}

export const getInvoices = ({ payload }) => request.get(getInvoicesList(payload))

export const getInvoicesTypes = () => request.get(getTypes)

export const getInvoiceDownload = ({ payload }) => request.get(getInvoice(payload), configs)
